import { Component, Input, OnInit } from '@angular/core';
import { GeneralValuationData } from '../models/generalValuationData';
import { ParticipantOverview } from 'src/app/calibration/_interfaces/participant-overview.interface';
import { BaseClass } from 'src/app/shared/classes/base';
import { ToastController } from '@ionic/angular';
import { TranslationService } from 'src/app/shared/services/translation.service';

@Component({
    selector: 'app-management-leadership-table',
    templateUrl: './management-leadership-table.component.html',
    styleUrls: ['./management-leadership-table.component.scss'],
})
export class ManagementLeadershipTableComponent extends BaseClass implements OnInit {
    public _user:  Partial<ParticipantOverview>;
    @Input() set user(value: Partial<ParticipantOverview>) {
        this._user = value;
    }
    constructor(
        protected _toastController: ToastController,
        protected _translationService: TranslationService
      ) {
        super(_toastController, _translationService);
      }

    ngOnInit() { }

}
